import React from "react";
import { withRouter } from "react-router-dom";
import ErrorPage from "./pages/ErrorPage";

class ErrorBoundary extends React.Component {

  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  componentDidCatch = (error, info) => {
    this.setState({hasError: true, error, info});

    const errorMessage = error?.message || ""
    const errorStack = (error?.stack || "")
      .replace(errorMessage, "")
      .split("\n    ")

    // send error details to backend (audit)
    this.props.countryApiRequest
      ?.post(
        "/audit/error_frontend",
        {
          stack: errorStack,
          error: errorMessage,
          from_: this.props.from || "main",
          path: this.props.location.pathname + this.props.location.search,
          agent: window.navigator?.userAgent ?? ""
        },
        {publicRequest: true, audit: true}
      )
      ?.catch((error) => { console.error(error);});
  }

  render() {
    const { children, component, hide } = this.props;

    const { hasError } = this.state;

    if (hasError) {
      if (component) {
        return component;
      }
      if (hide) {
        return null;
      }
      if (this.props.activeCountry) {
        return <ErrorPage />;
      }

    }

    return <>{children}</>;
  }
}

export default withRouter(ErrorBoundary);
